// extracted by mini-css-extract-plugin
export default {"resetButton":"bVFc7hS","controlPanel":"OsgOCfB"};